import { render, staticRenderFns } from "./NewList.vue?vue&type=template&id=fd0a9a00&scoped=true&"
import script from "./NewList.vue?vue&type=script&lang=js&"
export * from "./NewList.vue?vue&type=script&lang=js&"
import style0 from "./NewList.vue?vue&type=style&index=0&id=fd0a9a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0a9a00",
  null
  
)

export default component.exports